import React from 'react'
import { useTranslation } from "react-i18next"

import { InfoTooltip } from '../InfoTooltip'
import { isElectric } from '../../utils/utils';

function ReviewVehicleProperties({ localizationAssets, seats, fuel, consumption, displayExcess, excessForExtras, doors, bags, handbags, transmission, safetyDeposit, style }) {
  const { t } = useTranslation();
  return (
    <div style={style} className="info-board board-background">
      <div className="row">
        <div className="col-7">
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={localizationAssets[isElectric(fuel) ? 'electricIconMobile' : 'gasIconMobile']} alt="" /></div>
            <div className="txt"><b>{isElectric(fuel) ? t('range') : t('consumption')}:</b><small><i>{consumption}</i></small></div>
          </div>
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={require("../../assets/images/ico-transmission.png")} alt="" /></div>
            <div className="txt"><b>{t('transmisson')}:</b> {t('vehicles-' + transmission, '')}</div>
          </div>
          {displayExcess ?
            <div className="item d-flex align-items-center">
              <div className="ico"><img src={require("../../assets/images/ico-franquia.png")} alt="" /></div>
              <div className="txt"><b>{t('excess')}:</b>
                <span className="pr-1">{excessForExtras ? '€ ' + excessForExtras : t('noExcess')}</span>
                <InfoTooltip id={'review-excess-info'} text={t('excessExplanation')} />
              </div>
            </div>
            : ''}
        </div>
        <div className="col-5">
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={require("../../assets/images/ico-ocupantes.png")} alt="" /></div>
            <div className="txt"><b>{t('seats')}:</b> {seats}</div>
          </div>
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={require("../../assets/images/ico-portas.png")} alt="" /></div>
            <div className="txt"><b>{t('doors')}:</b> {doors}</div>
          </div>
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={require("../../assets/images/ico-big_bag.svg")} alt="" /></div>
            <div className="txt"><b>{t('bags')}:</b> {bags}</div>
          </div>
          <div className="item d-flex align-items-center">
            <div className="ico"><img src={require("../../assets/images/ico-malas.png")} alt="" /></div>
            <div className="txt"><b>{t('handbags')}:</b> {handbags}</div>
          </div>
          
        </div>
      </div>
    </div>
  )
}

export default ReviewVehicleProperties